import { Grid, Icon } from "@mui/material";
import SoftTypography from "components/SoftTypography";

function CartelError() {
  return (
    <Grid container textAlign={"center"} py={3}>
      <Grid item xs={12}>
        <Icon
          sx={{
            width: "50px",
          }}
          color="error"
        >
          error
        </Icon>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="h6">Error</SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="caption" component="p" color="text">
          Hubo un error al cargar los datos. Por favor, intente nuevamente.
        </SoftTypography>
      </Grid>
    </Grid>
  );
}
export default CartelError;
